<template>
  <div>
    
    <!-- Upload Form -->
    <form
      :id="
        id.form
      ">
      <input
        type="file"
        name="image"
        :id="
          id.input
        "
        accept="image/png, image/jpeg"
        @input="
          () => submit()
        "
      />
    </form>

    <!-- Loader -->
    <div 
      v-loading.fullscreen.lock="loader"
      element-loading-background="rgba(0, 0, 0, 0.4)">
    </div>
  </div>
  
</template>

<script lang="js">

// Services
import { NonScFeature } from '../feature'

/**
 * @typedef FormElement
 * @type {Object}
 * @property {HTMLFormElement}  form  - Upload Form
 * @property {HTMLInputElement} input - Update Input
 */

export default {
  props: {
    trigger: Number,
    type: {
      type    : String,
      default : null
    }
  },
  data() {

    /** @type {FormElement} */
    const element = {
      form  : null,
      input : null,
    }

    return {
      loader: false,
      id: {
        form  : 'upload-form',
        input : 'upload-image',
      },
      element,
    }
  },
  computed: {
    image() {
      return NonScFeature.image
    }
  },
  watch: {
    trigger() {
      this.element.input.click()
    },
    loader(value) {
      this.$emit('loading', value)
    }
  },
  mounted () {

    // Init Form
    this.element.form = (
      document.getElementById(this.id.form)
    )

    // Init Input
    this.element.input = (
      document.getElementById(this.id.input)
    )
  },
  methods: {
    async submit() {

      // Elements
      const { form, input } = this.element

      // Upload File
      await this.upload(
        new FormData(form)
      )

      // Reset Input
      input.value = null
    },
    async upload(payload) {

      // Loading
      this.loader = true

      try {

        // Upload Type
        const type = this.type

        // Upload Image
        const result = (
          await this.image.upload(type, payload)
        )

        // Emit Result
        this.$emit(
          'result', { type, ...result }
        )
      }
      catch ({ message }) {
        
        // Error Info
        console.warn(
          'nonsc-image-upload', message
        )
        
        // Error Event
        this.$emit(
          'error', 'Upload Failed'
        )
      }
      finally {
        
        // Loaded
        setTimeout(
          () => this.loader = false, 400
        )
      }
    }
  }
}

</script>
<style lang="css" scoped>

form {
  display: none;
}

</style>


// WEBPACK FOOTER //
// src/features/nonsc/components/NonScImageUpload.vue